var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 0.5C6.05228 0.5 6.5 0.947715 6.5 1.5V2.5H13.5V1.5C13.5 0.947715 13.9477 0.5 14.5 0.5C15.0523 0.5 15.5 0.947715 15.5 1.5V2.52469C18.0267 2.77555 20 4.90733 20 7.5V16.5C20 19.2614 17.7614 21.5 15 21.5H5C2.23858 21.5 0 19.2614 0 16.5V7.5C0 4.90733 1.97334 2.77555 4.5 2.52469V1.5C4.5 0.947715 4.94772 0.5 5.5 0.5ZM2.17071 6.5H17.8293C17.4175 5.33481 16.3062 4.5 15 4.5H5C3.69378 4.5 2.58254 5.33481 2.17071 6.5ZM18 8.5H2V16.5C2 18.1569 3.34315 19.5 5 19.5H15C16.6569 19.5 18 18.1569 18 16.5V8.5ZM4 11.5C4 10.9477 4.44772 10.5 5 10.5H9C9.55229 10.5 10 10.9477 10 11.5V15.5C10 16.0523 9.55229 16.5 9 16.5H5C4.44772 16.5 4 16.0523 4 15.5V11.5ZM8 12.5H6V14.5H8V12.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 0.5C6.05228 0.5 6.5 0.947715 6.5 1.5V2.5H13.5V1.5C13.5 0.947715 13.9477 0.5 14.5 0.5C15.0523 0.5 15.5 0.947715 15.5 1.5V2.52469C18.0267 2.77555 20 4.90733 20 7.5V16.5C20 19.2614 17.7614 21.5 15 21.5H5C2.23858 21.5 0 19.2614 0 16.5V7.5C0 4.90733 1.97334 2.77555 4.5 2.52469V1.5C4.5 0.947715 4.94772 0.5 5.5 0.5ZM2.17071 6.5H17.8293C17.4175 5.33481 16.3062 4.5 15 4.5H5C3.69378 4.5 2.58254 5.33481 2.17071 6.5ZM18 8.5H2V16.5C2 18.1569 3.34315 19.5 5 19.5H15C16.6569 19.5 18 18.1569 18 16.5V8.5ZM4 11.5C4 10.9477 4.44772 10.5 5 10.5H9C9.55229 10.5 10 10.9477 10 11.5V15.5C10 16.0523 9.55229 16.5 9 16.5H5C4.44772 16.5 4 16.0523 4 15.5V11.5ZM8 12.5H6V14.5H8V12.5Z",
    fill: "url(#paint0_linear_83_113)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_83_113",
    x1: 28.5,
    y1: 34,
    x2: 1.8689e-7,
    y2: 0.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0DC9FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520833,
    stopColor: "#4F30FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F00F8E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.e4f07c5a445ba87761470eae346afe6a.svg";
export { ForwardRef as ReactComponent };